"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pino_1 = tslib_1.__importDefault(require("pino"));
const fs_1 = tslib_1.__importDefault(require("fs"));
const path = `${__dirname}/logs`;
const isWeb = typeof window !== 'undefined';
const messageKey = 'msg';
const level = process.env.LOG_LEVEL
    ? process.env.LOG_LEVEL.toLowerCase()
    : 'info';
const inDevelopment = process.env.NODE_ENV === 'development';
if (!global._LOGGER_SETUP) {
    global._LOGGER_SETUP = 'true';
    console.debug(`@osmosys/logger | Logger is starting for first time... | LOG_LEVEL: ${level}`);
}
// add path to logs if fs
if (!isWeb && fs_1.default.existsSync && !fs_1.default.existsSync(path)) {
    try {
        fs_1.default.mkdirSync(path);
    }
    catch (e) {
        console.error({ error: e }, 'Failed to mkdirSync');
    }
}
const options = () => (Object.assign({ changeLevelName: 'severity', level,
    messageKey, name: 'osmosys', redact: {
        paths: [
            'requestContext.headers.Authorization',
            'requestContext.headers.authorization',
        ],
    }, useLevelLabels: true }, (isWeb
    ? {
        browser: {
            asObject: true,
        },
        level: inDevelopment ? level : 'warn',
        serialize: true,
    }
    : {
        prettyPrint: process.env.PRETTY_LOGGING ||
            ((process.env.NODE_ENV === 'development' || !process.env.NODE_ENV) &&
                !process.env.JSON_LOGGING)
            ? {
                colorize: true,
                levelFirst: true,
                messageKey,
                translateTime: true,
            }
            : false,
    })));
exports.mainLogger = pino_1.default(options());
exports.mainLogger.debug({
    env: {
        JSON_LOGGING: process.env.JSON_LOGGING || 'not set',
        NODE_ENV: process.env.NODE_ENV || 'not set',
        PRETTY_LOGGING: process.env.PRETTY_LOGGING || 'not set',
    },
    options,
}, 'Logger options');
exports.logger = exports.mainLogger.child({});
exports.logger.debug({
    ctx: {
        isWeb,
        options,
        'process.env.JSON_LOGGING': process.env.JSON_LOGGING,
        'process.env.LOG_LEVEL': process.env.LOG_LEVEL,
        'process.env.NODE_ENV': process.env.NODE_ENV,
    },
}, 'Logger started');
exports.logger.log = exports.logger.info;
exports.logger.silly = exports.logger.debug;
// interface IOsmosysLoggerOptsWithMessage
//   extends Exclude<Partial<IOsmosysLoggerOpts>, 'module' | 'message'> {
//   message: string;
//   msg: string;
//   module: any;
// }
// type OsmosysLog = (message: string, opts?: IOsmosysLoggerOpts) => string;
exports.createOsmosysLogger = (defaults) => {
    // mainLogger.debug(
    //   { ...defaults, fn: 'createOsmosysLogger' },
    //   'Creating logger for module %s submodule %s',
    //   defaults && defaults.module,
    //   defaults && defaults.subModule
    // );
    return exports.mainLogger.child(Object.assign({ app: 'osmosys', logName: 'specific' }, defaults));
};
exports.osmosysLogger = exports.createOsmosysLogger();
// osmosysLogger.debug('Logger created', {
//   fn: 'createOsmosysLogger',
//   module: 'utils',
// });
exports.default = exports.logger;
//# sourceMappingURL=logger.js.map